<template>
  <div>
    <div class="permission-alert-msg" v-show="!(ifTeamleaderPermission)">
      You have only view permission.
    </div>
    <div class="smtpDetails" :disabled="!(ifTeamleaderPermission)">
      <div class="smtpFields">
        <txt
          class="margin-b-s"
          type="email"
          label="Login *"
          v-model="formData.login"
          name="login"
          v-validate="{required: true, regex:emailRegex, max:100}"
          :classname="errors.has('login')"
          :errormsg="errors.first('login')"
        />
        <txt
          class="margin-b-s"
          type="password"
          label="Password *"
          v-model="formData.password"
          name="password"
          v-validate="{required: true}"
          :classname="errors.has('password')"
          :errormsg="errors.first('password')"
        />
        <txt
          class="margin-b-s"
          type="text"
          label="Outgoing Server *"
          v-model="formData.outgoingServer"
          name="outServer"
          v-validate="'required'"
          :classname="errors.has('outServer')"
          :errormsg="errors.first('outServer')"
        />
        <txt
          class="margin-b-s"
          type="text"
          label="SMTP Port *"
          v-model="formData.port"
          name="port"
          v-validate="{required: true}"
          :classname="errors.has('port')"
          :errormsg="errors.first('port')"
        />
        <txt
          type="text"
          label="Display Name *"
          v-model="formData.displayName"
          name="name"
          v-alpha-num
          v-validate="{required: true}"
          :classname="errors.has('name')"
          :errormsg="errors.first('name')"
        />
        <tl-checkbox
          name="sslRequire"
          class="custom-label margin-t-25px"
          label="Requires SSL encryption"
          v-model="formData.sslRequire"
        />
        <div class="send-mail margintop-32" v-show="ifTeamleaderPermission">
          <div>
            <span v-if="!sentMail" @click="sendTestMail">Send Test Mail</span>
            <span v-if="sentMail" @click="sendTestMail">Resend Test Mail</span>
          </div>
          <div class="sent-mail" v-if="sentMail">
            <span>
              Mail Sent to {{formData.login}}
              <img class="custom-height" src="@/assets/checked.svg" />
            </span>
          </div>
        </div>
      </div>
    </div>
    <tick-animation v-if="showSuccessMsg"></tick-animation>

    <bottom-action-container class="placeAtEnd">
      <btn-skip @navClicked="$emit('skip')"></btn-skip>
      <template slot="end">
        <btn-grp>
          <btn text="Previous" type="secondary" @click="$emit('previous')" />
          <btn text="Next" type="primary" @click="saveSmtp" v-show="(ifTeamleaderPermission || ifSuperAdmin || ifAnchor)"/>
          <!-- <btn text="Next" type="primary" @click="$emit('skip')" v-show="(ifAnchor || ifSuperAdmin)"/> -->
        </btn-grp>
      </template>
    </bottom-action-container>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";
import * as globalRegexVar from "@/apis/config.js";

export default {
  mounted() {
    this.fetchAll();
    this.emailRegex = globalRegexVar.Regex.EMAIL;
    this.getOrgLeIdList();
  },
  activated() {
    this.fetchAll();
    this.getOrgLeIdList();
  },
  computed: {
    ...mapState({
      smtpSettingsData: state => state.data,
      isFetching: state => state.isFetching,
      isSaving: state => state.isSaving,
      isDeleting: state => state.isDeleting
    }),
    ...mapGetters({
      getleid: "onboard/legal_entities/legal_entity_ID"
    }),
    ...mapState("onboard/organization", {
      orgId: state => state.id
    }),
    le_id() {
      if (this.$route.params.entity_index) {
        return this.getleid(this.$route.params.entity_index);
      }
      return this.getleid(0);
    },
    isLoading() {
      return this.isFetching;
    },
    ifAnchor() {
      return localStorage.getItem("userRole") == "ANCHOR" ? true : false;
    },
    ...mapState("onboard/organization", {
      orgIds: state => state.id,
    }),
    ifTeamleaderPermission() {
      if(this.role === 'ADMIN') {
        return true;
      } else if(this.role === 'TEAMLEADER') {
        if(this.miscValue) {
          return true;
        } 
        else {
          return false;
        }
      } else {
        return false
      }

      // if(this.role === 'TEAMLEADER' || this.role === 'ADMIN') {
      //   if(this.miscValue) {
      //   return true;
      //   } else {
      //     return false;
      //   }
      // }
      // else {
      //  return true
      // }
    },
    ifSuperAdmin() {
      return localStorage.getItem("userRole") == "SUPERADMIN" ? true : false;
    },
  },
  data() {
    return {
      emailRegex: null,
      mode: "add",
      editModel: "in-page",
      sentMail: false,
      isClickedOnSendmail: false,
      showBtn: true,
      formData: {
        login: "",
        password: "",
        outgoingServer: "",
        port: "",
        displayName: "",
        sslRequire: true
      },
      showSuccessMsg: false,
      miscValue: false,
      role: ""
    };
  },
  methods: {
    ...mapActions("onboard/smtpSettings/", {
      act_fetchAll: "fetchAll",
      act_create: "create"
    }),

    ...mapActions({
      getOrgLeList: "onboard/organization/getOrgLeIdList",
    }),

    /** Function to validate the form data and to resend the email test mail*/
    sendTestMail() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.isClickedOnSendmail = true;
          try {
            this.performAction();
          } catch (err) {
            this.toast = true;
            this.errmsg = err;
          }
        }
      });
    },
    /** Function to validate the form data */
    saveSmtp() {
      if(this.ifAnchor || this.ifSuperAdmin) {
          this.nextPage();
        } else {
      this.isClickedOnSendmail = false;
      this.$validator.validateAll().then(result => {
        if (result) {
          this.performAction();
        } else {
          this.$el
            .querySelector(
              '[data-vv-name="' + this.$validator.errors.items[0].field + '"]'
            )
            .focus();
          this.$el
            .querySelector(
              '[data-vv-name="' + this.$validator.errors.items[0].field + '"]'
            )
            .scrollIntoView({
              behavior: "smooth",
              block: "center",
              inline: "center"
            });
        }
      });
      }
    },
    /* function to hide success message and navigate to next screen */
    hideSuccessMsg() {
      setTimeout(() => {
        this.showSuccessMsg = false;
        this.$emit("next");
      }, 1000);
    },
    /** Submit the form data to server */
    async performAction() {
      try {
        let obj = {
          data: {
            org_id: this.orgId,
            le_id: this.le_id,
            ...this.formData
          }
        };
        this.$root._data.isSaving = true;
        let res = await this.act_create(obj.data);
        setTimeout(() => {
          if (res.data.status) {
            if (!this.isClickedOnSendmail) {
              this.showSuccessMsg = true;
              this.hideSuccessMsg();
            } else {
              this.$root._data.isSaving = false;
              this.sentMail = true;
              return res;
            }
            this.$root._data.isSaving = false;
          }
        }, 500);
      } catch (err) {
        this.$root._data.isSaving = false;
        this.toast = true;
        this.errmsg = err;
      }
    },
    /** Function to fetch data from server and to set the form data */
    async fetchAll() {
      try {
        let res = await this.act_fetchAll(this.le_id);
        if (res.data.payload && Object.keys(res.data.payload.data).length) {
          this.formData.password = res.data.payload.data.SMTPSetting.password;
          this.formData.port = res.data.payload.data.SMTPSetting.port;
          this.formData.outgoingServer =
            res.data.payload.data.SMTPSetting.outgoingServer;
          this.formData.displayName =
            res.data.payload.data.SMTPSetting.displayName;
          this.formData.login = res.data.payload.data.SMTPSetting.login;
          this.formData.sslRequire =
            res.data.payload.data.SMTPSetting.sslRequire;
        }
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },

    async getOrgLeIdList() {
      const org = this.orgIds;
      const le = this.le_id;
      //console.log("Org:",org);
      //console.log("Le ID",le);
      let bodyParams = {};
      let  data = await this.getOrgLeList({
        data: {
            ...bodyParams
        }
      });
      this.role = data.data.user.userRole;
      this.miscValue = data.data.user.permissions.misc ? true : false;
      //console.log("PL-3406",data);
    },

    /* function is use to move next page as user role is anchor */
    nextPage() {
      this.$emit('skip');
    },

  }
};
</script>
<style lang="scss" scoped>
@import "@/scss/components/margins.scss";
.smtpFields {
  margin-top: 10px;
  span {
    font-size: 14px;
    font-weight: 500;
    color: #6e6e6e;
  }
  .custom-label {
    font-size: 16px;
    font-weight: 600;
    color: #646464;
  }
  .custom-height {
    height: 16px;
    margin-top: 10px;
  }
}
.send-mail {
  display: flex;
  cursor: pointer;
  span {
    font-size: 16px;
    font-weight: 600;
    color: #34c0be;
    line-height: normal;

    &:hover {
      width: 120px;
      height: 19px;
      font-size: 16px;
      font-weight: 600;
      color: #5d409f;
      line-height: normal;
    }
  }
  .sent-mail {
    margin-top: -12px;
    span {
      font-size: 14px;
      font-weight: 500;
      font-style: italic;
      color: #6e6e6e;
      margin-left: 28px;
    }
  }
}

.permission-alert-msg {
  background-color: #f8d7da;
  padding: 1rem 1rem;
  margin-top: 1rem;
  margin-bottom: 1rem;
  font-weight: 600;
  color: #842029;
  border: 1px solid transparent;
  border-radius: .25rem;
  border-color: #f5c2c7;
}
</style>
